import {
    calculateRouteCoordinatesForLocation,
    nearestPointOnRoute,
    routeDistanceMap
} from "../../components/util/Geometry";
import _ from "lodash";

export const FEATURE_OVERLAY_ADD_FEATURE = "FEATURE_OVERLAY_ADD_FEATURE";
export const FEATURE_OVERLAY_REMOVE_FEATURE = "FEATURE_OVERLAY_REMOVE_FEATURE";
export const FEATURE_OVERLAY_UPDATE_FEATURE = "FEATURE_OVERLAY_UPDATE_FEATURE";
export const FEATURE_OVERLAY_CLEAR_FEATURES = "FEATURE_OVERLAY_CLEAR_FEATURES";
export const FEATURE_OVERLAY_SET_DATUM = "FEATURE_OVERLAY_SET_DATUM";
export const FEATURE_OVERLAY_ROUTE_DATUM_DISTANCES = "FEATURE_OVERLAY_ROUTE_DATUM_DISTANCES";
export const ADD_FEATURE_OVERLAY_CORRECTION = "ADD_FEATURE_OVERLAY_CORRECTION";
export const REMOVE_FEATURE_OVERLAY_CORRECTION = "REMOVE_FEATURE_OVERLAY_CORRECTION";


export function addFeatureOverlayCorrection(data) {
    return {
        type: ADD_FEATURE_OVERLAY_CORRECTION,
        data
    };
}

export function removeFeatureOverlayCorrection(index) {
    return {
        type: REMOVE_FEATURE_OVERLAY_CORRECTION,
        index
    };
}

export function featureOverlayAddFeature(feature) {
    return {
        type: FEATURE_OVERLAY_ADD_FEATURE,
        feature
    };
}

export function featureOverlayUpdateFeature(index, feature) {
    return {
        type: FEATURE_OVERLAY_UPDATE_FEATURE,
        index,
        feature
    };
}

export function featureOverlayRemoveFeature(index) {
    return {
        type: FEATURE_OVERLAY_REMOVE_FEATURE,
        index
    };
}

export function featureOverlayClearFeatures() {
    return {
        type: FEATURE_OVERLAY_CLEAR_FEATURES
    };
}

export function featureOverlaySetDatum(timestamp, location) {
    return (dispatch, getState) => {
        if (timestamp) {
            const routeCoordinateData = getState().playlist.data.route_locations;
            const routeCoordinateSystemID = getState().playlist.data.system_id;
            const elr = calculateRouteCoordinatesForLocation(timestamp, routeCoordinateData, routeCoordinateSystemID);
            dispatch({
                type: FEATURE_OVERLAY_SET_DATUM,
                datum: {
                    location,
                    routePosition: elr
                }
            });
        } else {
            dispatch({
                type: FEATURE_OVERLAY_SET_DATUM,
                datum: null
            });
        }
        dispatch(updateRouteDatumDistances());
    }
}

export function updateRouteDatumDistances() {
    return (dispatch, getState) => {
        const state = getState();
        const datum = state.featureOverlay.datum;
        const useSnappedGeometry = state.snappedRoute;
        const sourceIndex = state.playlist.position.sourceIndex;
        const routeGeometry = _.get(state.playlist.data, ['video', sourceIndex]);

        if (datum && routeGeometry) {
            const routeDatum = nearestPointOnRoute(datum.location[1], datum.location[0], routeGeometry, useSnappedGeometry);
            const distanceMap = routeDistanceMap(routeDatum, routeGeometry, useSnappedGeometry);
            dispatch({
                type: FEATURE_OVERLAY_ROUTE_DATUM_DISTANCES,
                routeDatum,
                distanceMap
            });
        } else {
            dispatch({
                type: FEATURE_OVERLAY_ROUTE_DATUM_DISTANCES
            });
        }
    }
}
